import React, { useContext } from "react";
import Form from "react-bootstrap/Form";
import { QuizContext } from "../../App";

const FormCommentQuiz = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  return (
    <Form
      data-bs-theme={theme}
      style={{ fontWeight: "600", padding: "5%" }}
    >
      <Form.Label>
        COMMENT <span style={{
          fontSize: "1rem",
          fontWeight: "400",
          fontStyle: "italic"
        }}>
          optional
        </span>
      </Form.Label>
      {!quizContext.state.comment
        ? <>
          {quizContext.state.recom === "REC"
            || quizContext.state.recom === "UNREC"
            ? <Form.Control
              type="text"
              as="textarea"
              rows={2}
              data-bs-theme={theme}
              style={{
                border: theme === "dark"
                  ? "1px solid #77797c"
                  : "1px solid #212529"
              }}
              placeholder={quizContext.state.recom === "REC"
                ? "Say thank you to the quiz contributor and tell other users why you recommend this quiz"
                : "Report the issue to the quiz contributor and tell other users why you do not recommend this quiz"
              }
              onChange={(e) => quizContext.dispatch({
                type: "getComment",
                payload: e.target.value
              })}
            />
            : null
          }
        </>
        : <>
          {quizContext.state.recom === "REC"
            || quizContext.state.recom === "UNREC"
            ? <Form.Control
              type="text"
              as="textarea"
              rows={2}
              data-bs-theme={theme}
              style={{
                border: theme === "dark"
                  ? "1px solid #77797c"
                  : "1px solid #212529"
              }}
              value={quizContext.state.comment}
              onChange={(e) => quizContext.dispatch({
                type: "getComment",
                payload: e.target.value
              })}
            />
            : null
          }
        </>
      }

    </Form>
  )
}

export default FormCommentQuiz